import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  boxesContainer: {
    flexDirection: 'row',
    marginVertical: indent * 0.4,
    marginLeft: indent * 1.3,
    marginBottom: indent * 0.5,
  },
  boxesContainerUpdate: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 6,
    marginVertical: indent * 0.4,
    marginLeft: indent * 1.3,
    marginBottom: indent * 0.5,
  },
  moneyBold: {
    fontWeight: '600',
  },
  fqvContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: indent * 0.4,
    marginBottom: indent * 0.5,
    justifyContent: 'space-between',
  },
  fqvTextContainer: {
    marginHorizontal: indent * 0.5,
  },
  fqvText: {
    fontSize: 12,
  },
  progressBarContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: indent * 0.4,
    marginBottom: indent * 0.25,
  },
  circleCheckMarkIcon: {
    marginRight: indent * 0.35,
  },
  circleUnFilledFont: {
    fontSize: 17,
  },
  circleCheckedFilledFont: {
    fontSize: 19,
  },
  coachDescription: {
    width: '90%',
    lineHeight: 17,
  },
  pqvText: {
    fontWeight: '800',
  },
  supportPathDescription: {
    width: '90%',
    alignSelf: 'flex-start',
    lineHeight: 17,
  },
});
